import {
  Box,
  Button,
  Card,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import DatatableComponent from "helpers/DatatableComponent";
import { connect } from "react-redux";
import { mapStateToProps } from "store/helpers/mapState";
import { mapDispatchToProps } from "store/helpers/mapDispatch";
import PermissionDetails from "./PermissionDetails";
import TabPanel from "helpers/TabPanel";
import LeaveCalendar from "components/UI/LeaveCalendar";
import StatusLayout from "components/Status";

const AnnualLeave = (props) => {
  const { FetchDetails, systemSettings } = props;
  const mainBackground = systemSettings?.mainBackground;

  const date = new Date();
  // const [selected, setSelected] = useState(location?.state?.status ?? "All");
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const [info, setInfo] = useState();
  const [positions, setPositions] = React.useState([]);
  const [tabValue, setTabValue] = useState(0);
  // Add this line to fix the error:
  const [showAllDialog, setShowAllDialog] = useState(false);
  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("en-US", {
      month: "short",
      day: "2-digit",
    });
  };

  // Calculate days remaining
  const calculateDaysRemaining = (endDate) => {
    const currentDate = new Date();
    const end = new Date(endDate);
    const timeDifference = end - currentDate;
    const dayDifference = Math.floor(timeDifference / (1000 * 3600 * 24));
    return dayDifference; // Calculate based on end date
  };

  // const [searchQuery, setSearchQuery] = useState("");

  // const fetchFilteredData = (query) => {
  //   const filteredList = list.filter(
  //     (item) =>
  //       item.names?.toLowerCase().includes(query.toLowerCase()) ||
  //       item.StaffPosition?.name?.toLowerCase().includes(query.toLowerCase())
  //   );
  //   setList(filteredList);
  // };

  // fetch staff positions
  const loadPositions = async () => {
    const resp = await FetchDetails(`/api/staff-position/viewAll`);
    if (resp.status) {
      const positionList = resp?.data?.list?.map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setPositions([...positionList, { value: null, label: "Unclassified" }]);
    }
  };

  useEffect(() => {
    loadPositions();
  }, []);


  const columns = [
    {
      name: "resource.names",
      label: "Names",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta) => {
          const rowData = list[tableMeta.rowIndex];
          return rowData?.resource?.names || "N/A";
        },
      },
    },
    {
      name: "resource.positionId",
      label: "Position",

      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta) => {
          const rowData = list[tableMeta.rowIndex];
          const position = positions.find(
            (position) => position.value === rowData?.resource?.positionId
          );
          return (
            <Typography style={{ fontSize: "14px" }}>
              {position ? position.label : "Unclassified"}
            </Typography>
          );
        },
      },
    },
    {
      name: "category.name",
      label: "Leave Type",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (v, tableMeta, updateData) => {
          const item = list[tableMeta.rowIndex];
          const leaveType = item?.category?.name || "Other Leave";

          return (
            <div
              style={{
                backgroundColor: "#CBDCDC",
                borderRadius: "10px",
                padding: "4px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography style={{ color: mainBackground, fontSize: "14px" }}>
                {leaveType}
              </Typography>
            </div>
          );
        },
      },
    },
    {
      label: "Start Date",
      name: "startDate",
      options: {
        filter: true,
        sort: true,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          const item = list[rowIndex];
          const startDate = item?.startDate;

          return (
            <Typography
              style={{ fontSize: "14px" }}
              className="text-blue-700 text-sm"
            >
              {startDate ? formatDate(startDate) : "N/A"}
            </Typography>
          );
        },
      },
    },
    {
      label: "End Date",
      name: "endDate",
      options: {
        filter: true,
        sort: true,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          const item = list[rowIndex];
          const endDate = item?.endDate;

          return (
            <Typography style={{ fontSize: "14px" }} className="text-blue-700 ">
              {endDate ? formatDate(endDate) : "N/A"}
            </Typography>
          );
        },
      },
    },
    {
      label: "Days Remaining",
      name: "remainingDays",
      options: {
        filter: true,
        sort: true,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          const item = list[rowIndex];
          const endDate = item?.endDate;
          const daysRemaining = endDate
            ? calculateDaysRemaining(endDate)
            : null;

          return (
            <Typography style={{ fontSize: "14px" }} className="">
              {daysRemaining >= 0 ? daysRemaining : 0}
            </Typography>
          );
        },
      },
    },
    {
      label: "Status",
      name: "status",
      options: {
        filter: true,
        sort: true,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          const item = list[rowIndex];
          const status = item?.status;

          return status ? (
            <StatusLayout status={status} />
          ) : (
            <Typography>N/A</Typography>
          );
        },
      },
    },
  ];

  /*useEffect(() => {
    SetSelectedMenu({
      menu: "annual",
      title: "",
    });
  }, []);*/

  return (
    <div className="">
      <Dialog
        maxWidth={"lg"}
        fullWidth={true}
        open={open}
        onClose={() => setOpen(true)}
      >
        <DialogContent>
          <PermissionDetails id={info?.id} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Dialog for View All */}
      <Dialog
        maxWidth={"lg"}
        fullWidth={true}
        open={showAllDialog}
        onClose={() => setShowAllDialog(false)}
      >
        <DialogContent>
          <DatatableComponent
            search={false}
            searchfield={true}
            viewColumns={false}
            onRowClick={(data, { rowIndex }) => {
              setInfo(list[rowIndex]);
              setOpen(true);
            }}
            processData={(data) => {
              // Update filter logic to include only "on-leave" status
              const approvedLeaves = data.data.filter(
                (item) =>
                  item.status === "on-leave" && item.startDate && item.endDate
              );
              setList(approvedLeaves);
              return {
                ...data,
                data: approvedLeaves,
                recordsTotal: approvedLeaves.length,
                recordsFiltered: approvedLeaves.length,
              };
            }}
            elevation={1}
            columns={columns}
            url={`/api/request/datatable?status=approved`}
            title={"All Approved  Leaves"}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowAllDialog(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      <Card>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          {/* <Tabs
            value={tabValue}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab label="All Approved Leaves" {...a11yProps(0)} />
            <Tab label="Calendar View" {...a11yProps(1)} />
          </Tabs> */}
        </Box>
        <TabPanel value={tabValue} index={0}>
          <Box display="flex" justifyContent="flex-end" mb={1}>
            <Button variant="outlined"
              sx={{ backgroundColor: mainBackground, color: "white",
                ":hover": {backgroundColor:mainBackground, color: "white" }
               }}

              onClick={() => setShowAllDialog(true)}>
              View All
            </Button>
          </Box>
          <DatatableComponent
            search={false}
            searchfield={false}
            viewColumns={false}
            onRowClick={(data, { rowIndex }) => {
              setInfo(list[rowIndex]);
              setOpen(true);
            }}
            processData={(data) => {
              // Filter and only show first 5
              const approvedLeaves = data.data.filter(
                (item) =>
                  item.status === "on-leave" && item.startDate && item.endDate
              );
              setList(approvedLeaves);
              return {
                ...data,
                data: approvedLeaves.slice(0, 5),
                recordsTotal: approvedLeaves.length,
                recordsFiltered: approvedLeaves.length,
              };
            }}
            elevation={1}
            columns={columns}
            url={`/api/request/datatable?status=approved`}
            title={"Approved  Leaves"}
          />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <LeaveCalendar />
        </TabPanel>
      </Card>
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(AnnualLeave);
